<select class='my-3' *ngIf='vizService.getInteractivity(viz) && vizService.getInteractionsLength(viz)'
    (change)="onOptionsSelected($event)">
    <option disabled selected value>
        {{ vizService.getTitleSelect(viz) }}</option>
    <option *ngFor="let point of vizService.getInteractionTrace(viz,0)" [value]="point.ids">
        {{ point.text }}
    </option>
</select>